'use client';

import ProductListItems from '@/features/products/components/list/productListSection/productListItems';
import { ProductListRowItem } from '@/features/products/components/list/productListSection/types';
import { useProductListTaxonData } from '@/features/products/state/list/context';

interface ProductListBoxProps {
  isPartnerListing?: boolean;
  items: ProductListRowItem[];
}

const ProductListBox = ({ items }: ProductListBoxProps) => {
  const stateTaxonData = useProductListTaxonData();

  const taxonData = {
    taxonBreadcrumbs: stateTaxonData?.breadcrumb || [],
    taxonName: stateTaxonData?.name || '',
    taxonSlug: stateTaxonData?.slug || ''
  };

  return <ProductListItems itemsToRender={items} taxonData={taxonData} />;
};

export default ProductListBox;
